import React, { useState } from "react";
import Timeline from "react-image-timeline";
import Details from "./components/Details";
import {} from "react-bootstrap";

const events = require("./events.js").default;

function App() {
    const [details, setDetails] = useState({
        opened: false,
        title: "",
        text: "",
        people: [],
        locations: [],
        events: [],
        dates: [],
        summary: "",
        learnMore: "",
        imageUrl: "",
        date: ""
    });

    const setTimelineEvent = timelineEvent => {
        const {
            title,
            text,
            people,
            locations,
            events,
            dates,
            summary,
            learnMore,
            imageUrl,
            date
        } = timelineEvent;
        setDetails({
            ...details,
            opened: true,
            title,
            text,
            people,
            locations,
            events,
            dates,
            summary,
            learnMore,
            imageUrl,
            date
        });
    };

    function goBack() {
        setDetails({ ...details, opened: false });
    }

    return (
        <div className="App">
            {!details.opened ? (
                <>
                    <h1 className="display-2 text-center mt-5 mx-5">
                        The Native American Impact
                    </h1>
                    <p className="lead text-center mb-4">By Andrew Richerson</p>
                    <Timeline
                        events={events.map(event => {
                            return {
                                ...event,
                                onClick: () => setTimelineEvent(event)
                            };
                        })}
                    />
                </>
            ) : (
                <Details details={details} goBack={goBack} />
            )}
        </div>
    );
}

export default App;
